import { render, staticRenderFns } from "./OpenApplications.vue?vue&type=template&id=62515211"
import script from "./OpenApplications.vue?vue&type=script&lang=js"
export * from "./OpenApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports